import React from 'react';
import Image from 'app/Components/Shared/Image/image';
import '../debtPayment.scss';

const BasicImage = (props) => {
  return <Image src={props.src} className={'' + (props.classname ? props.classname : '')} />;
};

export default BasicImage;
